var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-2",staticStyle:{"margin-bottom":"10px","margin-top":"10px"}},[_c('a-alert',{attrs:{"type":"error","message":_vm.message,"banner":"","closable":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }